import React, { useEffect } from 'react'
import { Box, InputLabel } from '@material-ui/core'
import { Controller, useFormContext } from 'react-hook-form'

import { Select, LoadingFeedback } from 'components'

import useFetch from 'hooks/useFetch'
import useStyles from './styles'

import * as service from 'service'

import theme from 'theme'

const AcceptanceForm = ({ setLoadingStats }) => {
  const classes = useStyles()
  const { control, errors, watch } = useFormContext()
  const documentId = watch('documentId')
  const { response, isLoading } = useFetch(
    service.dponet.privacyPolicies.get,
    {
      noPagination: true,
      collectAccepted: true,
      consentForm: true,
      hasAnswers: true,
    },
    [],
  )
  const documents = response?.data?.privacyPolicies

  const { response: versionsResponse, isLoading: versionsIsLoading } = useFetch(
    service.dponet.privacyPolicies.listVersions,
    { privacyPolicyId: documentId, hasAnswers: true },
    [documentId],
    !!documentId,
  )
  const documentVersions = versionsResponse?.data?.documentVersions || []

  const versionOptions =
    documentVersions.map((item) => ({
      name: String(item?.version),
      id: String(item?.version),
    })) || []

  const defaultVersionOptions = [
    ...versionOptions,
    { name: 'Todos', id: 'all' },
  ]

  useEffect(() => {
    setLoadingStats(isLoading || versionsIsLoading)
  }, [isLoading, versionsIsLoading])

  return (
    <Box display="flex" width="100%" paddingBottom={1}>
      <LoadingFeedback open={isLoading} />
      {!isLoading && (
        <Box
          display="flex"
          flexDirection="column"
          width="100%"
          gridGap={theme.spacing(1.5)}
        >
          <InputLabel className={classes.label}>
            Selecione o documento:
          </InputLabel>
          <Controller
            as={
              <Select
                items={documents || []}
                fieldName="title"
                className={classes.input}
                error={!!errors.documentId}
                helperText={errors?.documentId?.message}
                label="Selecione o documento"
              />
            }
            mode="onChange"
            control={control}
            name="documentId"
          />
          {documentId && (
            <>
              <InputLabel className={classes.label}>
                Selecione a versão do documento:
              </InputLabel>
              <Controller
                as={
                  <Select
                    items={defaultVersionOptions}
                    className={classes.input}
                    error={!!errors.documentVersionId}
                    helperText={errors?.documentVersionId?.message}
                    label="Selecione a versão"
                  />
                }
                mode="onChange"
                control={control}
                name="documentVersionId"
              />
            </>
          )}
        </Box>
      )}
    </Box>
  )
}

export default AcceptanceForm
